import React from 'react';
import { formatPhoneForDisplay } from '../../utils/format-phone.util';

interface FormattedPhoneProps {
  value?: string | null;
  className?: string;
}

export function FormattedPhone({ value, className }: FormattedPhoneProps) {
  if (!value) {
    return null;
  }

  return <span className={className}>{formatPhoneForDisplay(value)}</span>;
}

export default FormattedPhone;
